import styles from './styles.module.css';
import Image from "@/shared/components/Image/new";
import { formatAuthorNames } from '@/shared/functions/formatAthorNames';

const NotasDeSeccion = (props) => {
    
    const CLIPPING = '3_2_300x200';
    const { data } = props;

    return (
        <div className={`${styles['listado-container']}`}>
            {data && data.length > 0 &&
                data.map((element, id) => {
                    const { url, title, subtitle, authors } = element;
                    
                    return (
                    <div className={`${styles['item-container']}`} key={element.url + id}>    
                        
                        <div className={`${styles['listado-img-texto-container']}`}>
                            
                                <div className={`${styles['container-image']}`}>
                                    <Image
                                        element={element}
                                        clipping={CLIPPING}
                                        priority={id === 0}
                                        width={300}
                                        height={200}
                                        className={styles["img"]}
                                    />
                                </div>
                                <div className={`${styles['texto-container']}`}>
                                    
                                    <div className={styles['texto-principal']}>
                                        <span className={`${styles['volanta']}`}>{subtitle}</span>
                                        <h2 className={`${styles['titulo']}`}>{title}</h2>
                                    </div>

                                    {authors && authors.length > 0 && (
                                        <div className={`${styles["autor"]}`}>
                                            Por {authors.slice(0, 2).map((author, index) => {
                                                const authorName = formatAuthorNames(author.name);
                                                return (
                                                    <span key={author.slug || index}>
                                                        {author.slug ? (
                                                            <a href={`/autor/${author.slug}`}>{authorName}</a>
                                                        ) : (
                                                            authorName
                                                        )}
                                                        {index === 0 && authors.length > 1 && ' y '}
                                                    </span>
                                                );
                                            })}
                                        </div>
                                    )}
                                </div>
                        </div>

                        {url && <a href={url} className={styles['fantasma-link']} aria-label={`Leer más sobre ${title}`}></a>}
                    </div>    
                    );
                })}
        </div>
    );
};

export default NotasDeSeccion;